import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-services-details-page",
    templateUrl: "./services-details-page.component.html",
    styleUrls: ["./services-details-page.component.scss"],
})
export class ServicesDetailsPageComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    pageData = "";
    constructor(
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "kepler": {
                        this.pageData = "kepler";
                        this.pageTitleArea = [
                            {
                                title: "Platforms",
                                subTitle: "Kepler",
                            },
                        ];
                        this.servicesDetailsImage = [
                            {
                                img: "assets/img/services/KeplerArch.png",
                            },
                        ];
                        this.servicesDetailsDesc = [
                            {
                                subTitle: "Kepler",
                                title1: "About Kepler Platform",
                                paragraphText1:
                                    "<p>Finding inspiration in the stars Named after famed astronomer Johannes Kepler, Nasa’s Kepler Space Telescope set out on a nine-year voyage to explore the structure and diversity of previously undiscovered planets. During its mission, Kepler produced glimpses into never before seen reaches of the galaxy and forever accelerated our understanding of the cosmos. In that same spirit of discovery ExxonMobil’s Kepler Upstream Data Platform, with its shared namesake, delivers a new vantage point on data for our organization. </p>",
                                paragraphText2:
                                    "<p>This view lets us harness the power of data across our enterprise and deliver on our mission to meet the world’s growing needs for energy. The future of energy is data In this era of rapid innovation, data is invaluable. From test results on a single well to global statistics that will drive future energy transition, the volume of data in our industry is growing exponentially. </p><p>But, just like the images from the Kepler space telescope, data must be made accessible before discovery can happen. The recognition of this by the Upstream business partnered with EMIT paved the way for the Upstream Data Foundation project (UDF). And from that, our very own Kepler was born.</p><p>The mission of Kepler as one of Upstream’s strategic data platforms is to enable us to use data and data tools to inform strategic decisions. Any data-driven project involves a lengthy process to build, configure, and deploy infrastructure before we can query the data. This often requires technical skill sets that are outside a team’s expertise. Kepler allows us to launch new data projects at scale by bypassing this initial phase. </p><p>Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows our teams to do what they do best –  use data to tackle business challenges head-on.</p>",
                                title2: "Important Facts",
                                title3: "Application Areas",
                                title4: "Technologies That We Use",
                                img1: "assets/img/services/kepler-introduction.png",
                                img2: "assets/img/services/charts.jpg",
                            },
                        ];
                        this.sidebarContactInfo = [
                            {
                                icon: "assets/img/icon/website-icon-removebg-preview.png",
                                title: "Website",
                                subTitle:
                                    '<a href="https://kepler-docs.apps.dp01.exxonmobil.com/">goto/Keplerdocs</a>',
                            },
                            {
                                icon: "assets/img/icon/chat-icon-removebg-preview.png",
                                title: "Zoom Channel",
                                subTitle: "#Kepler Community",
                            },
                            {
                                icon: "assets/img/icon/mail-icon-removebg-preview.png",
                                title: "Shared Mailbox",
                                subTitle:
                                    '<a href="MailTo:Kepler.support@exxonmobil.com">Kepler.support@exxonmobil.com</a>',
                            },
                        ];
                        this.sidebarServicesList = [
                            {
                                title: "AI & ML Development",
                                link: "services-details",
                            },
                            {
                                title: "Data Analytics",
                                link: "services-details",
                            },
                            {
                                title: "Data Science",
                                link: "services-details",
                            },
                            {
                                title: "Artificial Intelligence",
                                link: "services-details",
                            },
                            {
                                title: "Data Visualization",
                                link: "services-details",
                            },
                        ];
                        this.sidebarDownloadFile = [
                            {
                                title: "PDF Download",
                                icon: "bx bxs-file-pdf",
                                link: "services-details",
                            },
                            {
                                title: "Services Details.txt",
                                icon: "bx bxs-file-txt",
                                link: "services-details",
                            },
                        ];
                        break;
                    }
                    case "mdp": {
                        this.pageTitleArea = [
                            {
                                title: "Platforms",
                                subTitle: "MDP",
                            },
                        ];
                        this.servicesDetailsImage = [
                            {
                                img: "assets/img/services/MDP.png",
                            },
                        ];
                        this.servicesDetailsDesc = [
                            {
                                subTitle: "Modern Day Platform ",
                                title1: "MDP Vision",
                                paragraphText1:
                                    "An integrated and modern data platform that centralize and exposes key unconventional datasets to end users, amplify business value, and enabling acceleration of critical decisions and insights through analytics.",
                                paragraphText2: "",
                                title2: "Important Facts",
                                title3: "Application Areas",
                                title4: "Technologies That We Use",
                                img1: "assets/img/projects/img2.jpg",
                                img2: "assets/img/services/charts.jpg",
                            },
                        ];
                        this.sidebarContactInfo = [
                            {
                                icon: "assets/img/icon/website-icon-removebg-preview.png",
                                title: "Website",
                                subTitle:
                                    '<a href="https://kepler-docs.apps.dp01.exxonmobil.com/"></a>',
                            },
                            {
                                icon: "assets/img/icon/chat-icon-removebg-preview.png",
                                title: "Zoom Channel",
                                subTitle: "",
                            },
                            {
                                icon: "assets/img/icon/mail-icon-removebg-preview.png",
                                title: "Shared Mailbox",
                                subTitle:
                                    '<a href="MailTo:Kepler.support@exxonmobil.com"></a>',
                            },
                        ];
                        this.sidebarServicesList = [
                            {
                                title: "AI & ML Development",
                                link: "services-details",
                            },
                            {
                                title: "Data Analytics",
                                link: "services-details",
                            },
                            {
                                title: "Data Science",
                                link: "services-details",
                            },
                            {
                                title: "Artificial Intelligence",
                                link: "services-details",
                            },
                            {
                                title: "Data Visualization",
                                link: "services-details",
                            },
                        ];
                        this.sidebarDownloadFile = [
                            {
                                title: "PDF Download",
                                icon: "bx bxs-file-pdf",
                                link: "services-details",
                            },
                            {
                                title: "Services Details.txt",
                                icon: "bx bxs-file-txt",
                                link: "services-details",
                            },
                        ];
                        break;
                    }
                    case "uda": {
                        this.pageTitleArea = [
                            {
                                title: "Platforms",
                                subTitle: "UDA",
                            },
                        ];
                        this.servicesDetailsImage = [
                            {
                                img: "assets/img/services/UDA.png",
                            },
                            {
                                img: "assets/img/services/UDA-Architecture.png",
                            },
                        ];
                        this.servicesDetailsDesc = [
                            {
                                subTitle: "Upstream Digital Accelerator",
                                title1: "About UDA Platform",
                                paragraphText1:
                                    "The Upstream Digital Accelerator (UDA) Data Platform or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets (i.e. Cold Lake and Kearl).",
                                paragraphText2:
                                    "Even though the Lakehouse was originally designed as a data foundation geared to support UDA pilots, the current iteration has evolved to become a comprehensive data and analytics platform catering to software developers, business users, and data scientists.",
                                title2: "Important Facts",
                                title3: "Application Areas",
                                title4: "Technologies That We Use",
                                img1: "assets/img/projects/img2.jpg",
                                img2: "assets/img/services/charts.jpg",
                            },
                        ];
                        this.sidebarContactInfo = [
                            {
                                icon: "assets/img/icon/website-icon-removebg-preview.png",
                                title: "Website",
                                subTitle:
                                    '<a href="https://kepler-docs.apps.dp01.exxonmobil.com/"></a>',
                            },
                            {
                                icon: "assets/img/icon/chat-icon-removebg-preview.png",
                                title: "Document Repository",
                                subTitle:
                                    '<a href="https://uda-data-platform-rtd.uda.xom.cloud/index.html">goto/lakehousedocs</a>',
                            },
                            {
                                icon: "assets/img/icon/mail-icon-removebg-preview.png",
                                title: "Data Catalogue",
                                subTitle:
                                    '<a href="https://usw-su1.azuredatacatalog.com/#/home">goto/datacatalogue(Access Required)</a>',
                            },
                        ];
                        this.sidebarServicesList = [
                            {
                                title: "AI & ML Development",
                                link: "services-details",
                            },
                            {
                                title: "Data Analytics",
                                link: "services-details",
                            },
                            {
                                title: "Data Science",
                                link: "services-details",
                            },
                            {
                                title: "Artificial Intelligence",
                                link: "services-details",
                            },
                            {
                                title: "Data Visualization",
                                link: "services-details",
                            },
                        ];
                        this.sidebarDownloadFile = [
                            {
                                title: "PDF Download",
                                icon: "bx bxs-file-pdf",
                                link: "services-details",
                            },
                            {
                                title: "Services Details.txt",
                                icon: "bx bxs-file-txt",
                                link: "services-details",
                            },
                        ];
                        break;
                    }
                    case "osdu": {
                        this.pageTitleArea = [
                            {
                                title: "Platforms",
                                subTitle: "OSDU",
                            },
                        ];
                        this.servicesDetailsDesc = [
                            {
                                subTitle: "Open Subsurface Data Universe",
                                title1: "About OSDU Platform",
                                paragraphText1:
                                    'An industry-wide initiative run by The <a href="https://www.opengroup.org/" target="_blank"> Open Group </a> to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of ExxonMobils Upstream Digital Data Foundation (UDDF) Project: UDDF is currently focused on surface and commercial data, whereas OSDU is focused on subsurface data. Opportunities are being evaluated to utilize OSDU components within the ExxonMobil environment and harmonize/interface with UDDF where it makes sense.',
                                paragraphText2: "",
                                title2: "Important Facts",
                                title3: "Application Areas",
                                title4: "Technologies That We Use",
                                img1: "assets/img/projects/img2.jpg",
                                img2: "assets/img/services/charts.jpg",
                            },
                        ];
                        this.servicesDetailsImage = [
                            {
                                img: "assets/img/services/OSDU.png",
                            },
                        ];
                        this.sidebarContactInfo = [
                            {
                                icon: "assets/img/icon/website-icon-removebg-preview.png",
                                title: "Website",
                                subTitle:
                                    '<a href="https://kepler-docs.apps.dp01.exxonmobil.com/"></a>',
                            },
                            {
                                icon: "assets/img/icon/chat-icon-removebg-preview.png",
                                title: "Zoom Channel",
                                subTitle: "",
                            },
                            {
                                icon: "assets/img/icon/mail-icon-removebg-preview.png",
                                title: "Shared Mailbox",
                                subTitle:
                                    '<a href="MailTo:Kepler.support@exxonmobil.com"></a>',
                            },
                        ];
                        this.sidebarServicesList = [
                            {
                                title: "AI & ML Development",
                                link: "services-details",
                            },
                            {
                                title: "Data Analytics",
                                link: "services-details",
                            },
                            {
                                title: "Data Science",
                                link: "services-details",
                            },
                            {
                                title: "Artificial Intelligence",
                                link: "services-details",
                            },
                            {
                                title: "Data Visualization",
                                link: "services-details",
                            },
                        ];
                        this.sidebarDownloadFile = [
                            {
                                title: "PDF Download",
                                icon: "bx bxs-file-pdf",
                                link: "services-details",
                            },
                            {
                                title: "Services Details.txt",
                                icon: "bx bxs-file-txt",
                                link: "services-details",
                            },
                        ];
                        break;
                    }
                    case "default": {
                        this.pageTitleArea = [
                            {
                                title: "Service Details",
                                subTitle: "AI & ML Development",
                            },
                        ];
                        break;
                    }
                }
            });

        this.titleService.setTitle("Platforms");
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "Platforms",
            subTitle: "",
        },
    ];
    servicesDetailsImage: DetailsImage[] = [
        {
            img: "assets/img/services/services-details1.jpg",
        },
    ];
    servicesDetailsDesc: DetailsDesc[] = [
        {
            subTitle: "AI & ML Development",
            title1: "About this Services",
            paragraphText1:
                "Improve Machine Learning algorithms by studying underfitting, overfitting, training, validation, n-fold cross validation, testing, and how hyperparameters could improve performance. Perform linear and logistic regressions in Python.",
            paragraphText2:
                "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using ‘Content here, content here’, making it look like readable English. Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable.",
            title2: "Important Facts",
            title3: "Application Areas",
            title4: "Technologies That We Use",
            img1: "assets/img/projects/img2.jpg",
            img2: "assets/img/services/charts.jpg",
        },
    ];
    servicesDetailsDescImportantFacts: ImportantFacts[] = [
        {
            title: "The Field of Data Science",
        },
        {
            title: "The Problem",
        },
        {
            title: "The Solution",
        },
        {
            title: "The Skills",
        },
        {
            title: "Statistics",
        },
        {
            title: "Mathematics",
        },
    ];
    servicesDetailsDescApplication: Application[] = [
        {
            title: "Manufacturing",
            icon: "flaticon-factory",
        },
        {
            title: "Healthcare",
            icon: "flaticon-hospital",
        },
        {
            title: "Automobile",
            icon: "flaticon-tracking",
        },
        {
            title: "Banking",
            icon: "flaticon-investment",
        },
        {
            title: "Real Estate",
            icon: "flaticon-house",
        },
        {
            title: "Logistics",
            icon: "flaticon-order",
        },
    ];
    servicesDetailsDescTechnologiesFeatures: TechnologiesFeatures[] = [
        {
            title: "JavaScript",
        },
        {
            title: "Python",
        },
        {
            title: "Java",
        },
        {
            title: "C/CPP",
        },
        {
            title: "PHP",
        },
        {
            title: "Swift",
        },
        {
            title: "C# (C- Sharp)",
        },
        {
            title: "Ruby",
        },
        {
            title: "SQL",
        },
    ];

    sidebarServicesList: ServicesList[] = [
        {
            title: "AI & ML Development",
            link: "services-details",
        },
        {
            title: "Data Analytics",
            link: "services-details",
        },
        {
            title: "Data Science",
            link: "services-details",
        },
        {
            title: "Artificial Intelligence",
            link: "services-details",
        },
        {
            title: "Data Visualization",
            link: "services-details",
        },
    ];
    sidebarDownloadFile: DownloadFile[] = [
        {
            title: "PDF Download",
            icon: "bx bxs-file-pdf",
            link: "services-details",
        },
        {
            title: "Services Details.txt",
            icon: "bx bxs-file-txt",
            link: "services-details",
        },
    ];
    sidebarContactInfo: ContactInfo[] = [
        {
            icon: "bx bx-user-pin",
            title: "Phone",
            subTitle: "+2145 354 5413",
        },
        {
            icon: "bx bx-map",
            title: "Location",
            subTitle: "New York, USA",
        },
        {
            icon: "bx bx-envelope",
            title: "Email",
            subTitle: "hello@wilo.com",
        },
    ];
}
class pageTitle {
    title: string;
    subTitle: string;
}
class DetailsImage {
    img: string;
}
class DetailsDesc {
    subTitle: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    paragraphText1: string;
    paragraphText2: string;
    img1: string;
    img2: string;
}
class ImportantFacts {
    title: string;
}
class Application {
    title: string;
    icon: string;
}
class TechnologiesFeatures {
    title: string;
}

class ServicesList {
    title: string;
    link: string;
}
class DownloadFile {
    title: string;
    icon: string;
    link: string;
}
class ContactInfo {
    icon: string;
    title: string;
    subTitle: string;
}
